(() => {
  'use strict';
  const init = () => {
  const root = document.querySelector('[data-sc-return-v11]');
  if (!root || root.dataset.returnReady) return;
  root.dataset.returnReady = 'true';
  const dialog = root.querySelector('#SCWelcomeV11');
  const quiet = root.querySelector('[data-return-quiet]');
  const cartReminder = root.querySelector('[data-return-cart]');
  const scope = root.dataset.customer || 'guest';
  const version = root.dataset.version;
  const key = `sc-return-v11:${scope}`;
  const storage = type => { try { return window[type]; } catch { return null; } };
  const persistent = storage('localStorage');
  const temporary = storage('sessionStorage');
  const read = (target, name, fallback = null) => {
    try { return JSON.parse(target?.getItem(name) || 'null') ?? fallback; } catch { return fallback; }
  };
  const write = (target, name, value) => { try { target?.setItem(name, JSON.stringify(value)); } catch {} };
  const preferences = () => read(persistent, key, {});
  const updatePreferences = changes => write(persistent, key, {...preferences(), ...changes});
  const session = read(temporary, key, {});
  const stored = preferences();
  const now = Date.now();
  const returning = Number.isFinite(stored.lastVisit) && now - stored.lastVisit >= 30 * 60 * 1000;
  if (returning) session.cartShown = false;
  const markVisit = () => updatePreferences({lastVisit: Date.now()});
  markVisit();
  let opener;
  let automatic = false;
  const visible = element => !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const modalBusy = () => [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner, #shopify-pc__prefs__dialog')].some(visible) || document.documentElement.classList.contains('cartDrawerOpen');
  const hideCart = () => { if (cartReminder) cartReminder.hidden = true; };
  const saveWelcome = () => {
    if (scope === 'guest') return;
    session.welcomeVersion = version;
    write(temporary, key, session);
    updatePreferences({welcomeVersion: version, welcomeQuiet: quiet ? quiet.checked : true});
  };
  const openWelcome = (trigger, auto = false) => {
    root.dataset.welcomeState = 'requested';
    if (!dialog) {root.dataset.welcomeState = 'missing'; return;}
    if (typeof dialog.showModal !== 'function') {root.dataset.welcomeState = 'unsupported'; return;}
    if (dialog.open) return;
    if (auto && (modalBusy() || document.visibilityState !== 'visible')) return;
    automatic = auto;
    opener = trigger || document.activeElement;
    hideCart();
    if (quiet) quiet.checked = preferences().welcomeQuiet !== false;
    dialog.showModal();
    root.dataset.welcomeState = 'open';
    root.querySelector('#SCWelcomeV11Title').focus({preventScroll: true});
    saveWelcome();
  };
  const closeWelcome = () => { saveWelcome(); dialog.close(); };
  dialog?.addEventListener('close', () => {
    root.dataset.welcomeState = 'closed';
    saveWelcome();
    const target = opener?.isConnected && opener.getClientRects().length ? opener : document.querySelector('[data-help-toggle]');
    if (!automatic || target !== document.body) target?.focus({preventScroll: true});
    automatic = false;
  });
  dialog?.addEventListener('click', event => {
    if (event.target.closest('[data-return-close]')) closeWelcome();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeWelcome();
    }
    if (event.target.closest('a')) saveWelcome();
  });
  quiet?.addEventListener('change', saveWelcome);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sc-open-welcome]');
    if (button) openWelcome(button);
  });
  const welcomeSeen = session.welcomeVersion === version || stored.welcomeVersion === version && stored.welcomeQuiet !== false;
  const memberPage = !!document.querySelector('sc-member-dashboard') || root.dataset.page === 'customers/account';
  if (root.dataset.autoWelcome === 'true' && root.dataset.designMode !== 'true' && memberPage && !welcomeSeen) window.setTimeout(() => openWelcome(null, true), 900);
  const dismissCart = () => {
    hideCart(); session.cartShown = true;
    write(temporary, key, session);
    updatePreferences({cartLastShown: Date.now()});
  };
  const cartAllowed = root.dataset.cartReminder === 'true' && root.dataset.designMode !== 'true'
    && !['cart', 'password', 'customers/account', 'customers/login', 'customers/register'].includes(root.dataset.page)
    && !memberPage && !document.querySelector('.scAuth--entry');
  const cartBusy = () => modalBusy() || !!document.querySelector('[data-help-toggle][aria-expanded="true"],details[data-updates][open]')
    || /^(INPUT|SELECT|TEXTAREA)$/.test(document.activeElement?.tagName || '') || document.activeElement?.isContentEditable;
  const delay = Math.max(20, Math.min(120, Number(root.dataset.cartDelay) || 45)) * 1000;
  let cartTimer, cartGeneration = 0, cartAttempts = 0;
  const eligible = () => cartAllowed && !session.cartShown && (!preferences().cartLastShown || Date.now() - preferences().cartLastShown >= 86400000);
  const scheduleCart = (wait = delay) => { clearTimeout(cartTimer); if (eligible() && cartAttempts < 24) cartTimer = setTimeout(showCart, wait); };
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(Number(cents || 0) / 100);
  const renderCart = cart => {
    const list = root.querySelector('[data-return-cart-items]');
    if (!list) return false;
    const fragment = document.createDocumentFragment();
    cart.items.forEach(item => {
      const row = document.createElement('li'), link = document.createElement('a');
      const url = new URL(item.url || '', location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
      link.href = url.href; link.className = 'scCartReminderV17__item';
      const rawImage = item.featured_image?.url || item.image;
      if (rawImage) {
        const imageURL = new URL(rawImage, location.origin);
        if (imageURL.protocol === 'https:' || imageURL.origin === location.origin) {
          const image = document.createElement('img'); imageURL.searchParams.set('width','220');
          image.src = imageURL.href; image.alt = ''; image.width = 88; image.height = 110; image.loading = 'lazy';
          image.addEventListener('error', () => { image.hidden = true; }, {once:true}); link.append(image);
        }
      }
      const copy = document.createElement('span'), title = document.createElement('strong'), options = document.createElement('small'), price = document.createElement('span');
      title.textContent = item.product_title || item.title;
      options.textContent = [item.variant_title === 'Default Title' ? '' : item.variant_title, 'Qty ' + item.quantity].filter(Boolean).join(' · ');
      price.textContent = money(item.final_line_price, cart.currency || 'USD'); price.className = 'scCartReminderV17__price';
      copy.append(title, options); link.append(copy, price); row.append(link); fragment.append(row);
    });
    list.replaceChildren(fragment);
    root.querySelector('[data-return-cart-count]').textContent = '(' + cart.item_count + ')';
    return list.children.length > 0;
  };
  const showCart = async () => {
    if (!cartReminder || !eligible()) return;
    if (document.visibilityState !== 'visible' || cartBusy()) { cartAttempts++; scheduleCart(5000); return; }
    const generation = ++cartGeneration, controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch((root.dataset.root || '/') + 'cart.js', {headers:{Accept:'application/json'}, credentials:'same-origin', cache:'no-store', signal:controller.signal});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (generation !== cartGeneration || !eligible()) return;
      if (!Array.isArray(cart?.items) || !(cart.item_count > 0)) { hideCart(); return; }
      if (document.visibilityState !== 'visible' || cartBusy()) { cartAttempts++; scheduleCart(5000); return; }
      if (!renderCart(cart)) return;
      cartReminder.hidden = false;
      session.cartShown = true; write(temporary, key, session);
      updatePreferences({cartLastShown:Date.now()});
    } catch { cartAttempts++; if (cartAttempts < 3) scheduleCart(15000); }
    finally { clearTimeout(timeout); }
  };
  scheduleCart();
  root.querySelector('[data-return-cart-close]')?.addEventListener('click', dismissCart);
  root.querySelectorAll('[data-return-cart-open]').forEach(link => link.addEventListener('click', dismissCart));
  document.addEventListener('sincere:cart-rendered', () => { cartGeneration++; hideCart(); cartAttempts = 0; scheduleCart(); });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-cart-drawer-open], [data-help-toggle], [data-sc-open-welcome], [data-rc-account-open], [data-search-open], [data-discovery-open]')) hideCart();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && cartReminder && !cartReminder.hidden) dismissCart(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') markVisit(); });
  window.addEventListener('pagehide', markVisit);
  window.addEventListener('pageshow', event => { if (event.persisted) hideCart(); });
  root.dataset.welcomeState = 'ready';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
